<template>
  <div>
    <section class="content" v-if="detail != ''">
      <div class="title">
        <p>{{ "项目：" + detail.project_name }}</p>
        <p>{{ "姓名：" + detail.user_name }}</p>
        <p></p>
      </div>
      <h3>一、双周价格</h3>
      <ul>
        <li>
          <label>单卫：</label>
          <a-input-number :min="0" v-model="double_one_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>双卫：</label>
          <a-input-number :min="0" v-model="double_two_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>三卫：</label>
          <a-input-number :min="0" v-model="double_three_guard" />
          <span>&nbsp;元</span>
        </li>
      </ul>
      <h3>二、退租价格</h3>
      <ul>
        <li>
          <label>单间：</label>
          <a-input-number :min="0" v-model="quit_one_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>单卫：</label>
          <a-input-number :min="0" v-model="quit_single_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>公共区域：</label>
          <a-input-number :min="0" v-model="quit_common_guard" />
          <span>&nbsp;元</span>
        </li>
      </ul>
      <h3>三、深度价格：</h3>
      <ul>
        <li>
          <label>深度：</label>
          <a-input-number :min="0" v-model="depth_guard" />
          <span>&nbsp;元</span>
        </li>
      </ul>
      <h3>四、开荒价格：</h3>
      <ul>
        <li>
          <label>1室：</label>
          <a-input-number :min="0" v-model="open_one_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>2室：</label>
          <a-input-number :min="0" v-model="open_two_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>3室：</label>
          <a-input-number :min="0" v-model="open_three_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>4室：</label>
          <a-input-number :min="0" v-model="open_four_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>5室：</label>
          <a-input-number :min="0" v-model="open_five_guard" />
          <span>&nbsp;元</span>
        </li>
        <li>
          <label>6室：</label>
          <a-input-number :min="0" v-model="open_six_guard" />
          <span>&nbsp;元</span>
        </li>
      </ul>
      <div class="submitStyle">
        <a-button type="primary" @click="onSubmit">提交</a-button>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      double_one_guard: "",
      double_two_guard: "",
      double_three_guard: "",
      quit_one_guard: "",
      quit_single_guard: "",
      quit_common_guard: "",
      depth_guard: "",
      open_one_guard: "",
      open_two_guard: "",
      open_three_guard: "",
      open_four_guard: "",
      open_five_guard: "",
      open_six_guard: "",
      detail: {}
    };
  },
  props: {
    editDetail: {}
  },
  mounted() {
    if (this.editDetail.name != undefined) {
      this.detail = this.editDetail;
      this.getDetail();
    }
  },
  watch: {
    editDetail() {
      this.detail = this.editDetail;
      // console.log(this.detail);
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      if (this.detail.project_account_config != "") {
        this.double_one_guard = Number(
          this.detail.project_account_config.double_one_guard
        );
        this.double_two_guard = Number(
          this.detail.project_account_config.double_two_guard
        );
        this.double_three_guard = Number(
          this.detail.project_account_config.double_three_guard
        );
        this.quit_one_guard = Number(
          this.detail.project_account_config.quit_one_guard
        );
        this.quit_single_guard = Number(
          this.detail.project_account_config.quit_single_guard
        );
        this.quit_common_guard = Number(
          this.detail.project_account_config.quit_common_guard
        );
        this.depth_guard = Number(
          this.detail.project_account_config.depth_guard
        );
        this.open_one_guard = Number(
          this.detail.project_account_config.open_one_guard
        );
        this.open_two_guard = Number(
          this.detail.project_account_config.open_two_guard
        );
        this.open_three_guard = Number(
          this.detail.project_account_config.open_three_guard
        );
        this.open_four_guard = Number(
          this.detail.project_account_config.open_four_guard
        );
        this.open_five_guard = Number(
          this.detail.project_account_config.open_five_guard
        );
        this.open_six_guard = Number(
          this.detail.project_account_config.open_six_guard
        );
      }
    },
    onSubmit() {
      let _this = this;
      this.$confirm({
        title: "提示",
        content: "确认后该员工在该项目产生的工单，按此价格结算。",
        onOk() {
          _this.onSubmitSure();
        }
      });
    },
    onSubmitSure() {
      let params = {
        double_one_guard:
          this.double_one_guard == "" ? 0 : this.double_one_guard,
        double_two_guard:
          this.double_two_guard == "" ? 0 : this.double_two_guard,
        double_three_guard:
          this.double_three_guard == "" ? 0 : this.double_three_guard,
        quit_one_guard: this.quit_one_guard == "" ? 0 : this.quit_one_guard,
        quit_single_guard:
          this.quit_single_guard == "" ? 0 : this.quit_single_guard,
        quit_common_guard:
          this.quit_common_guard == "" ? 0 : this.quit_common_guard,
        depth_guard: this.depth_guard == "" ? 0 : this.depth_guard,
        open_one_guard: this.open_one_guard == "" ? 0 : this.open_one_guard,
        open_two_guard: this.open_two_guard == "" ? 0 : this.open_two_guard,
        open_three_guard:
          this.open_three_guard == "" ? 0 : this.open_three_guard,
        open_four_guard: this.open_four_guard == "" ? 0 : this.open_four_guard,
        open_five_guard: this.open_five_guard == "" ? 0 : this.open_five_guard,
        open_six_guard: this.open_six_guard == "" ? 0 : this.open_six_guard,
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: this.detail.project_id,
        user_id: this.detail.id
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Guard/setUserAccountConfig";
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
            this.$emit("hideInSettle", false);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错了...");
        });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 10px 4%;
  .title {
    text-align: center;
    margin: 30px auto 10px;
    background: #ededed;
    padding: 10px 0;
    p {
      font-size: 14px;
      line-height: 24px;
    }
  }
  h3 {
    font-size: 14px;
    margin: 10px 0;
  }
  ul {
    li {
      margin-bottom: 10px;
      display: inline-block;
      width: 33.3%;
      span,
      p,
      h3,
      label {
        font-size: 14px;
      }
    }
  }
  .submitStyle {
    text-align: center;
    margin: 30px 0;
  }
}
</style>
